import React, { useState } from "react";
import { Row, Col, Form, Input, Button, Card } from "antd";
import { MailOutlined, SendOutlined } from "@ant-design/icons";
import { contactUs } from "../../Config/API/user";
import { success, error as errorMsg } from "../../common/Alerts/Message";
import "../AboutUs/AboutContact.css";

const { TextArea } = Input;

const ContactUs = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await contactUs(values);
      success("Thank you! Your message has been sent successfully.");
      form.resetFields();
    } catch (error) {
      errorMsg("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <Row justify="center" className="section-margin-bottom">
        <Col xs={24} md={16} lg={12} className="centered-text">
          <h1 className="contact-heading">Contact Us</h1>
          <p className="contact-description">
            Get in touch with SPOFLEX (PRIVATE) LTD. We&apos;d love to hear from you!
          </p>
        </Col>
      </Row>

      <Row justify="center">
        <Col xs={24} md={10}>
          <h2 className="subheading">Get In Touch</h2>

          <div className="section-margin-bottom">
            <Card className="contact-card">
              <Row align="middle">
                <Col span={4}>
                  <MailOutlined className="contact-icon" />
                </Col>
                <Col span={20}>
                  <h4 className="contact-info-title">Email</h4>
                  <p className="contact-info-subtitle">support@spoflex.com</p>
                </Col>
              </Row>
            </Card>
          </div>

          <Card className="contact-form-card">
            <h3 className="contact-form-heading">Send us a Message</h3>

            <Form form={form} layout="vertical" onFinish={handleSubmit} size="large">
              <Form.Item
                name="name"
                label="Full Name"
                rules={[{ required: true, message: "Please enter your full name" }]}>
                <Input placeholder="Enter your full name" />
              </Form.Item>

              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Please enter your email" },
                  { type: "email", message: "Please enter a valid email" }
                ]}>
                <Input placeholder="Enter your email address" />
              </Form.Item>

              <Form.Item
                name="message"
                label="Message"
                rules={[{ required: true, message: "Please enter your message" }]}>
                <TextArea rows={5} placeholder="Enter your message here..." />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  icon={<SendOutlined />}
                  className="send-button"
                  block>
                  Send Message
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ContactUs;
